<template>
  <div class="footer">
    <div class="relation">
      <el-row justify="space-around" align="center" style="width: 100vw">
        <el-col :xs="24" :sm="24" :md="{span:22,pull:1,push:1}" :lg="{span:22,pull:1,push:1}" :xl="{span:22,pull:1,push:1}">
          <el-row justify="space-around" >
            <el-col :xs="6" :sm="6" :md="{span:2,offset:3}" :lg="{span:2,offset:3}" :xl="{span:2,offset:3}"  style="display: flex;flex-direction: column;justify-content: center;align-items: center;align-content: center;">
              <MyIcon :img="imgs[0]"></MyIcon>
            </el-col>
            <el-col :xs="6" :sm="6" :md="2" :lg="2" :xl="2"  style="display: flex;flex-direction: column;justify-content: center;align-items: center;align-content: center;">
              <MyIcon :img="imgs[1]"></MyIcon>
            </el-col>
            <el-col :xs="6" :sm="6" :md="2" :lg="2" :xl="2"  style="display: flex;flex-direction: column;justify-content: center;align-items: center;align-content: center;">
              <MyIcon :img="imgs[2]"></MyIcon>
            </el-col>
            <el-col :xs="6" :sm="6" :md="2" :lg="2" :xl="2"  style="display: flex;flex-direction: column;justify-content: center;align-items: center;align-content: center;">
              <MyIcon :img="imgs[3]"></MyIcon>
            </el-col>
            <el-col :xs="6" :sm="6" :md="2" :lg="2" :xl="2"  style="display: flex;flex-direction: column;justify-content: center;align-items: center;align-content: center;">
              <MyIcon :img="imgs[4]"></MyIcon>
            </el-col>
            <el-col :xs="6" :sm="6" :md="2" :lg="2" :xl="2"  style="display: flex;flex-direction: column;justify-content: center;align-items: center;align-content: center;">
              <MyIcon :img="imgs[5]"></MyIcon>
            </el-col>
            <el-col :xs="6" :sm="6" :md="2" :lg="2" :xl="2"  style="display: flex;flex-direction: column;justify-content: center;align-items: center;align-content: center;">
              <MyIcon :img="imgs[6]"></MyIcon>
            </el-col>
            <el-col :xs="6" :sm="6" :md="2" :lg="2" :xl="2"  style="display: flex;flex-direction: column;justify-content: center;align-items: center;align-content: center;">
              <MyIcon :img="imgs[7]"></MyIcon>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <div class="copyright">
        <el-row>
          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" class="content-c1"><a  target="_blank" :href="hwadzanUrl">華藏淨宗弘化網</a></el-col>
          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" class="content-c2"><a  target="_blank" href="https://www.amtbcollege.com/">佛陀教育網路學院</a></el-col>
          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" class="content-c1"><a  target="_blank" href="https://rsd.amtb.tw/">儒釋道文化教育網</a></el-col>
          <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" class="content-c1"><a  target="_blank" href="https://new.jingzong.org/">澳洲淨宗學院</a></el-col>
          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" class="content-c1"><a  target="_blank" href="https://www.amtbcollege.org/order">訂閱佛陀教育雜誌</a></el-col>
        </el-row>

      </div>
      <div class="cop" style="width: 80vw">
        <el-row style="width: 100%">
          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" class="content-c31"><span class="content-c3">淨空老法師專集網</span></el-col>
          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" class="content-c0"><span class="content-c3" v-on:click="openmail">email:amtb@amtb.tw</span></el-col>
          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" class="content-c31"><span class="content-c3">建站日:1995.12.1</span></el-col>
          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" class="content-c31"><span class="content-c3">備案序號:<a href="http://beian.miit.gov.cn/" target="_blank">蘇ICP備06004660號</a></span></el-col>
          <el-col :push="-1" :xs="24" :sm="24" :md="3" :lg="3" :xl="3" class="content-c31"><span class="content-c3"><a href="/blog/privacy" target="_blank">Privacy隱私權政策</a></span></el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
  import YButton from '/components/YButton'
  import MyIcon from '/components/accountIcon'
  export default {
    data () {
      return {
        hwadzanUrl: '',
        imgs: [
          {id: '/blog/archives/211', url: '/static/images/rsd.png', title: '儒释道'},
          {id: 'https://www.facebook.com/amtbtw', url: '/static/images/facebook.png', title: '脸书'},
          {id: 'https://x.com/amtbtw', url: '/static/images/twitter.png', title: '推特'},
          {id: 'https://line.me/R/ti/p/@amtbtw', url: '/static/images/Line.png', title: 'Line'},
          {id: 'https://t.me/amtbtw', url: '/static/images/telegram.png', title: 'telegram'},
          {id: 'https://www.youtube.com/c/amtbhz', url: '/static/images/youtube.png', title: 'YouTube'},
          {id: 'https://www.instagram.com/amtb.tw', url: '/static/images/instagam.png', title: 'instagram'},
          // {id: 'http://i.youku.com/u/UMTI2MDAzNjM1NjA=?spm=a2h0c.8166622.PhoneSokuPgc_1.dportrait', url: '/static/images/youku.png', title: '优酷'}]
          {id: 'https://www.tiktok.com/@amtbhd', url: '/static/images/douyin.png', title: '抖音'}]
      }
    },
    methods: {
      openmail: function () {
        let locatUrl = 'mailto:amtb@amtb.tw'
        if (/ipad|iphone|mac/i.test(navigator.userAgent)) {
          var ifr = document.createElement('iframe')
          ifr.src = locatUrl
          ifr.style.display = 'none'
          document.body.appendChild(ifr)
        } else {
          window.location.href = locatUrl
        }
      }
    },
    mounted () {
      this.hwadzanUrl = 'https://www.hwadzan.tv/'
    },
    components: {
      YButton,
      MyIcon
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  .footer {
    border-top: 1px solid #e6e6e6;
    background: #fafafa;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-color: #ffffff;
  }

  .relation {
    width: 100vw;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 0 20px 0;
    background-color: #ffffff;
    border-bottom: 1px solid #e6e6e6;
  }

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #DBDBDB;
    width: 100%;
  }

  .copyright {
    width: 80vw;
    padding: 10px 0 0 20px;
    font-size: 13px;
  }
  .cop {
    width: 60vw;
    clear: both;
    padding: 10px 0 0 20px;
    font-size: 14px;
    padding-bottom: 100px;
  }

  .content-c0 {
    color: #5079d9;
    cursor: pointer;
    text-align: center;
    &:hover {
      color: #3A5FCD;
    }
  }
  .content-c31 {
    color: #5079d9;
    text-align: center;
  }

  .content-c1 {
    font-size: 14px;
    padding: 1px 10px 0;
    text-align: center;
    line-height: 25px;

  }
  .content-c2 {
    font-size: 14px;
    padding: 1px 10px 0;
    text-align: center;
    line-height: 25px;

  }
  .content-c3 {
    color: #000000;
    font-size: 12px;
    text-align: center;
    a{
      color: #000000;
    }
  }
</style>



// WEBPACK FOOTER //
// footer.vue?0691a470